/* eslint-disable max-len */

import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'lib/react-markdown';
import { Button, Col, Row } from 'reactstrap';
import Video from 'routes/Products/components/Video';
import { useWeek } from 'routes/Products/products/WLC/contexts/WeekContext';

const ActionVideo = ({ userAnalytics, scrollToActionItems, title = 'Your Action of the Week', noButton = false }) => {
  const { video } = useWeek();

  if (!video) return null;

  const { data, ...videoProps } = video;
  const { description } = data || {};

  return (
    <div>
      <Row className="d-md-none">
        <Col xs={12}>
          <h4>{title}</h4>
        </Col>
      </Row>
      <Row className="background-light-purple flex-column-reverse flex-md-row">
        <Col xs={12} lg={5}>
          <h4 className="d-none d-md-block">{title}</h4>
          {description && <ReactMarkdown>{description}</ReactMarkdown>}
        </Col>
        <Col xs={12} lg={7} className="pt-md-4 align-self-center" id="wlc-week-video">
          <Video save data={data} {...videoProps} userAnalytics={userAnalytics} />
        </Col>
      </Row>
      {!noButton && (
        <Row className="d-md-none">
          <Col xs={12}>
            <Button onClick={scrollToActionItems} className="mb-5" block color="primary" size="lg">
              Jump to Your Weekly Action Items
            </Button>
          </Col>
        </Row>
      )}
    </div>
  );
};

ActionVideo.propTypes = {
  userAnalytics: PropTypes.shape({}),
  scrollToActionItems: PropTypes.func
};

ActionVideo.defaultProps = {
  userAnalytics: null,
  scrollToActionItems: () => {}
};

export default ActionVideo;
